import React, { useContext } from 'react'
import { AccountsContext } from 'AccountsContext'
// import { isAndroidApp } from 'AccountsUtils'
import SupportHeader from '../SupportHeader'
import SupportBody from '../SupportBody'

const MobileDeviceSupport = () => {
  const {
    classesAddedToWidgetContainer,
  } = useContext(AccountsContext)
  return (
    <React.Fragment>
      {/* inserting support widget */}
      <div className={`${classesAddedToWidgetContainer} pushLeft`} style={{ maxWidth: '100vw' }}>
        {/* <If condition={isAndroidApp()}> */}
        <SupportHeader />
        {/* </If> */}
        <SupportBody verticalName="air" />
      </div>
    </React.Fragment>
  )
}

export default MobileDeviceSupport
